import React, { useEffect, useState } from "react";
import axios from "axios";
import Select from "react-select";
import { NavLink } from "react-router-dom";
import { auth as dashAuth } from "../firebase";
import PhoneInput from "react-phone-input-2";
import { useNavigate } from "react-router-dom";
import { fetchSignInMethodsForEmail } from "firebase/auth";
import { infDb, infStorage, infAuth } from "../firebase-inf";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { Timestamp, doc, setDoc } from "firebase/firestore";
import { createUserWithEmailAndPassword, sendEmailVerification } from "firebase/auth";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { signInWithEmailAndPassword } from "firebase/auth";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../firebase";


const genderOptions = [
  { value: "male", label: "Male" },
  { value: "female", label: "Female" },
  { value: "other", label: "Other" }
];
const isValidEmail = (email) => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};


 
const getPackagePrice = (followers, packageId) => {
  const count = parseInt(followers.replace(/[^0-9]/g, ""), 10);
  if (isNaN(count)) return "";
  const pricing = {
    package1: { low: "0", mid: "5,000", high: "10,000", custom: "Custom Pricing" },
    package2: { low: "5,000", mid: "10,000", high: "20,000", custom: "Custom Pricing" },
    package3: { low: "10,000", mid: "20,000", high: "30,000", custom: "Custom Pricing" },
  };
  if (count < 5000) return pricing[packageId].low;
  if (count < 25000) return pricing[packageId].mid;
  if (count < 60000) return pricing[packageId].high;
  return pricing[packageId].custom;
};




const getAddon1Price = (followers) => {
  const count = parseInt(followers.replace(/[^0-9]/g, ""), 10);
  if (isNaN(count)) return "";
  if (count < 5000) return "Rs 1,000";
  if (count < 25000) return "Rs 5,000";
  if (count < 60000) return "Rs 10,000";
  return "Custom Pricing";
};




const getAddon2Price = (followers) => {
  const count = parseInt(followers.replace(/[^0-9]/g, ""), 10);
  if (isNaN(count)) return "";
  if (count < 5000) return "2,000";
  if (count < 25000) return "7,500";
  if (count < 60000) return "15,000";
  return "Custom Pricing";
};




// Add this inside your component




const categoryOptions = [
  "Dresses", "Tops", "T-Shirts", "Shirts", "Lingerie", "Activewear", "Sportswear", "Ethnic", "Western", "Casual", "Formal", "Nightwear", "Swimwear",
].map((cat) => ({ value: cat, label: cat }));




const stepContent = [
  { heading: "Sign Up & Basic Details", description: "", image: "/influencer-1.webp" },
  { heading: "Select Package", description: "Choose your offering to the brand.", image: "/influencer-2.webp" },
  { heading: "", description: "", image: "/influencer-3.webp" },
];




const packages = [
  { id: "package1", description: "2 Instagram Posts (upto 5 images can be used) + 2 Stories, Collaboration with Influencer - validity within 3 months of Image Generation - No Ads" },
  { id: "package2", description: "2 Instagram Posts + 2 Stories + 1 Reel (upto 30 sec using AI), Collaboration with Influencer  - No Ads" },
  { id: "package3", description: "2 Instagram Posts + 2 Stories + 2 Reels (upto 30 sec each using AI), Collaboration with Influencer - No Ads" },
];




const InfluencerForm = () => {
 
  const navigate = useNavigate();
  const [contactNumber, setContactNumber] = useState("");
  const [step, setStep] = useState(0);
  const [showPassword, setShowPassword] = useState(false);
  const [showTermsModal, setShowTermsModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [countryOptions, setCountryOptions] = useState([]);
const [verificationSent, setVerificationSent] = useState(false);


  const [formData, setFormData] = useState({
    username: "", email: "", password: "", agreeTerms: false,
    name: "", instagram: "", phone: "", gender: "", countryCode: "",
    followers: "", category: [], packages: [],idType: "",
  idFile: null,
  idPreview: "", images: [], imagePreviews: [],
    customPackagePrice: "", customAddon1Price: "", customAddon2Price: "",
    verified: false, acceptedTerms: false, addon1: false, addon2: false, addon3: false,
    ip: "", location: "", customPackagePrices: {}
  });
const [errors, setErrors] = useState({
  email: "",
  contactNumber: "",
});


const checkEmailExists = async (email) => {
    try {
      const q = query(collection(infDb, "influencers"), where("email", "==", email));
      const querySnapshot = await getDocs(q);
      return !querySnapshot.empty;
    } catch (err) {
      console.error("Email check error:", err);
      return false;
    }
  };








const [checkingEmail, setCheckingEmail] = useState(false);


const handleIdUpload = (e) => {
  const file = e.target.files[0];
  if (file) {
    const previewUrl = URL.createObjectURL(file);
    setFormData((prev) => ({
      ...prev,
      idFile: file,
      idPreview: previewUrl,
    }));
  }
};






  useEffect(() => {
   




    axios.get("https://ipapi.co/json/")
      .then(res => {
        const { ip, city, region, country_name, country_code } = res.data;
        const loc = `${city}, ${region}, ${country_name} (${country_code})`;
        setFormData((prev) => ({ ...prev, ip, location: loc }));
      })
      .catch(err => console.error("IP fetch error:", err));
  }, []);




  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    if (type === "checkbox") {
      setFormData((prev) => ({ ...prev, [name]: checked }));
    } else if (name === "images" && files) {
      const newFiles = Array.from(files);
      const combinedImages = [...(formData.images || []), ...newFiles];
      if (combinedImages.length > 10) {
        alert("You can only upload up to 10 images.");
        return;
      }
      const previews = combinedImages.map(file => URL.createObjectURL(file));
      setFormData((prev) => ({ ...prev, images: combinedImages, imagePreviews: previews }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };




  const handleSelectChange = (selectedOptions) => {
    setFormData((prev) => ({ ...prev, category: selectedOptions }));
  };
 


 const isStep1Valid = () => {
  const {
    username, email, password, instagram,
    gender, followers, phone
  } = formData;


  return [
    username, email, password, instagram,
    gender, followers, phone
  ].every(field => field !== undefined && field !== null && field !== "");
};




  const getAllSelectedPackagePrices = () => {
    return formData.packages.map((desc) => {
      const pkg = packages.find(p => p.description === desc);
      if (!pkg) return { description: desc, price: "N/A" };
      const customPrice = formData.customPackagePrices?.[desc];
      const defaultPrice = getPackagePrice(formData.followers, pkg.id);
      return {
        description: desc,
        price: customPrice || defaultPrice,
      };
    });
  };




// ✅ Simplified and corrected InfluencerForm handleSubmit logic


const handleSubmit = async () => {
  if (!formData.acceptedTerms) return alert("Please accept the Terms & Conditions.");
  if (!formData.images.length) return alert("Please upload at least 1 image.");
    // 2.5 Upload ID file if provided
    const emailExists = await checkEmailExists(formData.email);
if (emailExists) {
  setErrors(prev => ({ ...prev, email: "This email is already registered." }));
  return;
}




  try {
    setLoading(true);


    // 1. Create user in Influencer Firebase Project
    const userCredential = await createUserWithEmailAndPassword(
      infAuth,
      formData.email,
      formData.password
    );
    const user = userCredential.user;
    const uid = user.uid;


   
 let idFileUrl = "";
    if (formData.idFile) {
      const idRef = ref(infStorage, `influencers/${uid}/id-${formData.idFile.name}`);
      await uploadBytes(idRef, formData.idFile);
      idFileUrl = await getDownloadURL(idRef);
    }
    // 2. Upload Terms & Conditions PDF
    let termsFileUrl = "";
    if (formData.acceptedTerms) {
      const pdfResponse = await fetch("/Influencer_Contract_Digital.pdf");
      const pdfBlob = await pdfResponse.blob();
      const termsRef = ref(infStorage, `influencers/${uid}/Influencer_Contract_Digital.pdf`);
      await uploadBytes(termsRef, pdfBlob);
      termsFileUrl = await getDownloadURL(termsRef);
    }


    // 3. Upload images
   // 3. Upload images
const imageUploadPromises = formData.images.map((file, i) => {
  const uniqueName = `${Date.now()}-${i}-${file.name}`;
  const fileRef = ref(infStorage, `influencers/${uid}/${uniqueName}`);
  return uploadBytes(fileRef, file)
    .then(() => getDownloadURL(fileRef));
});


const uploaded = await Promise.all(imageUploadPromises);
 // ✅ now contains URLs




    // 4. Prepare payload for influencer Firestore
      const payload = {
      uid,
      email: formData.email,
      name: formData.username,
      instagram: formData.instagram,
      phone: formData.phone,
      gender: formData.gender,
      countryCode: formData.countryCode,
      followers: formData.followers,
      packages: getAllSelectedPackagePrices(),
      acceptedTerms: formData.acceptedTerms,
      agreeTerms: formData.agreeTerms,
      category: formData.category.map(c => c.value),
      addon1: formData.addon1,
      addon2: formData.addon2,
      addon1Price: formData.customAddon1Price || getAddon1Price(formData.followers),
      addon2Price: formData.customAddon2Price || getAddon2Price(formData.followers),
      customPackagePrice: formData.customPackagePrice || "",
      images: uploaded,
      idType: formData.idType || "",
      idFileUrl: idFileUrl || "",
      ip: formData.ip,
      location: formData.location,
      termsFileUrl,
      createdAt: Timestamp.now()
    };




    // 5. Save to influencer Firestore
    await setDoc(doc(infDb, "influencers", uid), payload);


    // 6. Create user in Dashboard Auth
    await createUserWithEmailAndPassword(
      dashAuth,
      formData.email,
      formData.password
    );
     await setDoc(doc(db, "users", dashAuth.currentUser.uid), {
      uid,
      firstName: formData.username,
      lastName: "",
      email: formData.email,
      contactNumber: formData.phone || contactNumber || "",
      activePlan: "free",
      planType: "monthly",
      credits: 5,
      designRequestsLeft: 0,
      isSubscribed: false,
      lastPaymentAt: null,
      previousPlan: null,
      isPlanDowngrade: false,
      planChangeDate: null,
      hasUsedTrial: false,
      paymentDetails: {
        planType: null,
        subscriptionStart: null,
        subscriptionEnd: null,
        nextBillingDate: null,
      },
      chargebeeCustomerId: null, // Optional: you can add Chargebee integration later
      chargebeeSubscriptionId: null,
      createdAt: Timestamp.now(),
      emailVerified: false,
    });


    // 7. Login user to dashAuth and send email verification
    await signInWithEmailAndPassword(
      dashAuth,
      formData.email,
      formData.password
    );
    const dashUser = dashAuth.currentUser;


    await sendEmailVerification(dashUser);
    setVerificationSent(true);


    // 8. Poll for email verification
   if (user) {
  const emailCheckInterval = setInterval(async () => {
    await dashAuth.currentUser.reload();
    if (dashAuth.currentUser.emailVerified) {
      clearInterval(emailCheckInterval);
      alert("✅ Email verified! Redirecting...");
      navigate("/PricingPlan");// ✅ React-based redirect
    }
  }, 3000);
}


  } catch (err) {
    console.error("❌ Submission error:", err.message);
    alert("Submission failed: " + err.message);
  } finally {
    setLoading(false);
  }
};










  const { heading, description, image } = stepContent[step];
  const steps = ["INFLUENCER DETAILS", "SELECT PACKAGE", "UPLOAD IMAGES"];




const idOptions = [
  { value: "aadhar", label: "Aadhar Card" },
  { value: "pan", label: "PAN Card" },
  { value: "passport", label: "Passport" },
  { value: "driving", label: "Driving License" }
];




// Place this function above your JSX




  return (
   




    <div className="overflow-y-scroll no-scrollbar">
<div className="relative min-h-screen flex items-center justify-center
  bg-gradient-to-br from-[#f7faff] to-[#e8f0ff] bg-gray-100 font-sans px-4 py-8 overflow-hidden">
    <div className="absolute top-5 left-5">
        <a href="https://styleuai.com/">
      <img
        src="/logo.png"
        alt="StyleAI Logo"
        className="h-7 w-auto drop-shadow-md hover:scale-105 transition-transform duration-300"
      />
    </a>
    </div>
<div className="flex flex-col-reverse md:flex-row w-full max-w-6xl bg-white shadow-lg rounded-lg overflow-hidden mt-10">
       
       <div className="w-full md:w-1/2 overflow-y-visible p-6 sm:p-10">


     


<h2 className="text-2xl sm:text-3xl font-bold text-indigo-600 mb-1">Influencer Onboarding</h2>
          <h2 className="text-2xl sm:text-3xl font-bold text-indigo-600 mb-1">{heading}</h2>
          <p className="text-sm text-gray-600 mb-6">{description}</p>


<div className="flex justify-center mb-8">
  <div className="flex items-center w-full max-w-3xl">
    {steps.map((label, index) => (
      <div key={index} className="flex-1 flex items-center">
        <div className={`w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold
          ${index < step ? "bg-green-500 text-white" :
            index === step ? "border-2 border-green-500 text-green-700" : "bg-gray-300 text-gray-500"}`}>
          {index < step ? "✔" : index + 1}
        </div>
        {index < steps.length - 1 && (
          <div className={`flex-1 h-1 mx-2
            ${index < step ? "bg-green-500" : "bg-gray-300"}`} />
        )}
      </div>
    ))}
  </div>
</div>


{step === 0 && (
  <div className="space-y-5">




    <input
      name="username"
      placeholder="Name*"
      value={formData.username}
      onChange={handleChange}
      className="w-full py-2 px-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
    />
<div className="relative">
  <input
    name="email"
    placeholder="Email*"
    value={formData.email}
    onChange={(e) => {
      setFormData((prev) => ({ ...prev, email: e.target.value }));
    }}
    onBlur={async () => {
      if (formData.email.trim()) {
        setCheckingEmail(true);
        await checkEmailExists(formData.email);
        setCheckingEmail(false);
      }
    }}
    className="w-full py-2 px-3 border border-gray-300 rounded-md pr-10 focus:outline-none focus:ring-2 focus:ring-indigo-500"
  />
  {errors.email && (
    <p className="absolute left-0 top-full text-red-500 text-sm mt-[2px] mb-1">
      {errors.email}
    </p>
  )}
</div>






<div className="grid grid-cols-12 gap-3">
  {/* Gender */}
  <div className="col-span-6">
    <select
  name="gender"
  value={formData.gender}
  onChange={handleChange}
  className="w-full h-9 px-3 border border-gray-300 rounded-md bg-white
             focus:outline-none text-sm"
>
  <option className="text-sm" value="">Gender*</option>
  <option className="text-sm" value="male">Male</option>
  <option className="text-sm" value="female">Female</option>
  <option className="text-sm" value="other">Other</option>
</select>


  </div>


  {/* PhoneInput */}
  <div className="col-span-6">
   <div>
             
              <PhoneInput
  country={"in"}
  value={formData.phone}
  name="phone"
  onChange={(value) =>
    setFormData((prev) => ({ ...prev, phone: value }))
  }
  containerClass="!w-full"
  inputClass="!w-full p-3 rounded-lg border border-gray-300"
/>


               {errors.contactNumber && <p className="text-red-500 text-sm">{errors.contactNumber}</p>}
             </div>
    {errors.contactNumber && (
      <p className="text-red-500 text-sm mt-1">{errors.contactNumber}</p>
    )}
  </div>
</div>










    <div className="grid grid-cols-2 gap-3">
     <input
  name="instagram"
  placeholder="Instagram ID*"
  value={formData.instagram}
  onChange={handleChange}
  className="w-full py-2 px-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
/>




      <input
        name="followers"
        placeholder="Followers (e.g. 10000)"
        value={formData.followers}
        onChange={handleChange}
        className="w-full py-2 px-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
      />
    </div>




    <div>
      <div className="relative">
        <input
        placeholder="Password*"
          type={showPassword ? 'text' : 'password'}
          name="password"
          value={formData.password}
          onChange={handleChange}
          className="w-full py-2 px-3 border border-gray-300 rounded-md pr-10 focus:outline-none focus:ring-2 focus:ring-indigo-500"
        />
        {errors.password && <p className="text-red-500 text-sm mt-1">{errors.password}</p>}


        <button
          type="button"
          onClick={() => setShowPassword(!showPassword)}
          className="absolute right-3 top-2.5 text-gray-500"
        >
          {showPassword ? <FaEyeSlash /> : <FaEye />}
        </button>
      </div>
    </div>




  </div>
)}
          {step === 1 && (
            <div className="space-y-4 text-sm">
              <div>
                <label className="block font-medium mb-1">Select Categories</label>
                <Select isMulti options={categoryOptions} value={formData.category} onChange={handleSelectChange} />
            <p style={{ color: "black", fontStyle: "italic", fontSize: "0.775rem" }}>
  Multiple Select
</p>


              </div>
               <div>
             <h3 className="text-xl font-semibold mb-2 text-black">Choose Packages</h3>
<div className="grid grid-cols-1 md:grid-cols-1 gap-4">
  {packages.map((pkg, index) => (
    <label
      key={index}
      className={`border rounded p-1 cursor-pointer transition-all ${
        formData.packages.includes(pkg.description)
          ? "border-blue-500 bg-blue-100"
          : "border-gray-300 bg-white"
      }`}
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center">
         <input
  type="checkbox"
  name="packages"
  value={pkg.description}
  checked={formData.packages.includes(pkg.description)}
  onChange={(e) => {
    const { checked, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      packages: checked
        ? [...prev.packages, value]
        : prev.packages.filter((p) => p !== value),
    }));
  }}
className="mr-2 accent-blue-600"
/>


          <div>
            <p className="text-6 text-grey-500 font-normal">{pkg.description}</p>
            <p className="text-sm text-green-500">
  Price: Rs {
    formData.customPackagePrices?.[pkg.description]
      || getPackagePrice(formData.followers, pkg.id)
  }
</p>
          </div>
        </div>
      </div>
      {/* Optional: Per-package custom price */}
{formData.packages.includes(pkg.description) &&
  parseInt(formData.followers.replace(/\D/g, ""), 10) >= 60000 && (
    <input
      type="text"
      placeholder="Enter custom price"
      className="mt-2 p-2 border rounded w-full"
      value={formData.customPackagePrices?.[pkg.description] || ""}
      onChange={(e) => {
        const price = e.target.value;
        // Allow typing anything, but validate later
        setFormData((prev) => ({
          ...prev,
          customPackagePrices: {
            ...(prev.customPackagePrices || {}),
            [pkg.description]: price,
          },
        }));
      }}
    />
)}








    </label>
  ))}
</div>
              </div>
              <div>
  <label className="block font-medium mb-3">Add-ons</label>
  <div className="space-y-3">
    {[
      {
        id: "addon1",
        label: "Use generated images in Marketplaces (Amazon/ Myntra)",
        priceFn: getAddon1Price,
        priceField: "customAddon1Price",
      },
      {
        id: "addon2",
        label: "Use generated images in Ads (upto 3 months)",
        priceFn: getAddon2Price,
        priceField: "customAddon2Price",
      },
    ].map((addon) => {
      const followerCount = parseInt(formData.followers.replace(/\D/g, ""), 10);
      const defaultPrice = addon.priceFn(formData.followers);
      const isCustom = followerCount > 60000;




      return (
        <label key={addon.id} className="flex items-center justify-between p-1 border rounded cursor-pointer hover:border-gray-400">
          <span className="text-sm">{addon.label}</span>
          <div className="flex items-center gap-3">
           {formData[addon.id] && (
  isCustom ? (
    <input
      type="text"
      placeholder="Custom Price"
      value={formData[addon.priceField] || ""}
      onChange={(e) =>
        setFormData((prev) => ({ ...prev, [addon.priceField]: e.target.value }))
      }
      className="p-1 border rounded w-28 text-sm"
    />
  ) : (
    <span className="text-sm text-green-600">{defaultPrice}</span>
  )
)}


            <input
              type="checkbox"
              name={addon.id}
              checked={formData[addon.id] || false}
              onChange={handleChange}
              className="accent-indigo-600"
            />
          </div>
        </label>
      );
    })}
  </div>
</div>




            </div>
          )} {step === 2 && (
            <div className="space-y-6 text-sm">


<div className="border-2 border-dashed border-indigo-400 p-6 rounded-lg text-center space-y-4">
  <label className="block font-medium text-gray-700 text-left mb-2">Upload Identification Document</label>
 
  {/* Dropdown */}
  <div className="relative">
 <Select
  options={idOptions}
  value={idOptions.find(opt => opt.value === formData.idType)}
  onChange={(selected) => {
    setFormData(prev => ({ ...prev, idType: selected?.value || "" }));
  }}
  placeholder="Select ID Type"
  className="text-sm"
  styles={{
    control: (base) => ({
      ...base,
      padding: "2px",
      borderRadius: "6px",
      borderColor: "#d1d5db", // Tailwind gray-300
      textAlign: "left", // control box text alignment
    }),
    singleValue: (base) => ({
      ...base,
      textAlign: "left", // selected value
    }),
    menu: (base) => ({
      ...base,
      textAlign: "left", // entire dropdown menu
    }),
    option: (base, state) => ({
      ...base,
      textAlign: "left", // each option in the menu
      backgroundColor: state.isFocused ? "#f3f4f6" : "white", // Tailwind gray-100
      color: "#111827", // Tailwind gray-900
    }),
    placeholder: (base) => ({
      ...base,
      textAlign: "left",
    }),
  }}
/>


</div>




  {/* Upload Button */}
  <label htmlFor="idUpload" className="cursor-pointer flex flex-col items-center">
    <span className="inline-block mt-2 px-4 py-2 bg-indigo-600 text-white text-sm rounded hover:bg-indigo-700 transition-all">
      Browse File
    </span>
    <input
      type="file"
      id="idUpload"
      name="idFile"
      accept="image/*"
      onChange={handleIdUpload}
      className="hidden"
      required
    />
  </label>


  {/* Preview */}
  {formData.idPreview && (
    <div className="mt-4 border rounded overflow-hidden">
      <img src={formData.idPreview} alt="ID Preview" className="object-cover w-full h-28" />
    </div>
  )}
</div>






            <div className="border-2 border-dashed border-indigo-400 p-6 rounded-lg text-center">
              <div className="flex justify-between">
             <p> <label className="block font-medium text-gray-700 text-left mb-2">Upload your poses (Right, Left, Front, Back & 2 Random Poses)</label></p>
              </div>
  <label htmlFor="upload" className="cursor-pointer flex flex-col items-center">
    <span className="inline-block mt-2 px-4 py-2 bg-indigo-600 text-white text-sm rounded hover:bg-indigo-700 transition-all">
      Browse Files
    </span>
    <input
      type="file"
      name="images"
      multiple
      accept="image/*"
      onChange={handleChange}
      className="hidden"
      id="upload"
    />
  </label>
  {formData.imagePreviews.length > 0 && (
  <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 mt-4">
    {formData.imagePreviews.map((src, index) => (
      <div key={index} className="relative border rounded overflow-hidden">
        <img src={src} alt={`preview-${index}`} className="object-cover w-16 h-16" />
      </div>
    ))}
  </div>
)}


</div>
              <label className="flex items-start gap-2">
                <input type="checkbox" name="acceptedTerms" checked={formData.acceptedTerms} onChange={handleChange} className="accent-indigo-600 mt-1" />
                <div>
 
    I accept the <a
    href="/Influencer_Contract_Digital.pdf"
    target="_blank"
    rel="noopener noreferrer"
    className="font-medium text-indigo-600 cursor-pointer"
  > Terms & Conditions
  </a>    </div>
              </label>
            {showTermsModal && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div className="bg-white rounded-lg p-4 w-[90%] max-w-3xl h-[80%] overflow-hidden relative">
      <button
        onClick={() => setShowTermsModal(false)}
        className="absolute top-2 right-2 text-gray-600 hover:text-black text-xl"
      >
        &times;
      </button>
      <div className="h-full">
        <iframe
          src="/Influencer_Contract_Digital.docx"
          title="Terms and Conditions PDF"
          className="w-full h-full"
        ></iframe>
      </div>
    </div>
  </div>
)}     </div>
          )}
          <div className="flex justify-between mt-6 pb-6">
            {step > 0 && (
              <button onClick={() => setStep(step - 1)} className="px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300">Back</button>
            )}
            {step < 2 ? (
      <button
  disabled={checkingEmail}
  onClick={async () => {
    let hasError = false;


    // STEP 0 — Basic Info & Email Check
   if (step === 0) {
  const newErrors = {};
  let hasError = false;


  const requiredFields = ["username", "email", "password", "instagram", "gender", "followers", "phone"];
  requiredFields.forEach((field) => {
    if (!formData[field]?.toString().trim()) {
      newErrors[field] = "This field is required";
      hasError = true;
    }
  });


  if (formData.password && formData.password.length < 8) {
    newErrors.password = "Password must be at least 8 characters long.";
    hasError = true;
  }


 if (formData.email) {
  setCheckingEmail(true);
  const normalizedEmail = formData.email.trim().toLowerCase();
  const exists = await checkEmailExists(normalizedEmail);
  setCheckingEmail(false);
  if (exists) { // ✅ correct condition
    newErrors.email = "This email is already registered.";
    hasError = true;
  }
}




  setErrors((prev) => ({ ...prev, ...newErrors }));
  if (hasError) return;


  setStep(step + 1);
  return;
}


    if (step === 1) {
   if (!formData.category.length) {
      alert("Please select at least one category.");
      return;
   }
   if (!formData.packages.length) {
      alert("Please select at least one package.");
      return;
   }
   setStep(step + 1);
   return;
}


    // STEP 2 — Document & Poses Validation
    if (step === 2) {
      if (!formData.idFile || !formData.idType) {
        alert("Please upload a verification document and select its type.");
        return;
      }
      if (!formData.images || formData.images.length < 5) {
        alert("Please upload all required poses before proceeding.");
        return;
      }
      if (!formData.acceptedTerms) {
        alert("Please accept the Terms & Conditions.");
        return;
      }
      await handleSubmit();
    }
  }}
  className="px-4 py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700"
>
  {checkingEmail ? "Next" : step < 2 ? "Next" : "Submit"}
</button>

            ) : (
             <button
  onClick={handleSubmit}
  disabled={loading}
  className="ml-auto px-4 py-2 bg-indigo-600 text-white rounded flex items-center gap-2 hover:bg-indigo-700 disabled:opacity-70 disabled:cursor-not-allowed"
>
  {loading ? (
    <>
      <svg
        className="animate-spin h-5 w-5 text-white"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
        ></circle>
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
        ></path>
      </svg>
      Submitting...
    </>
  ) : (
    "Submit"
  )}
</button>


            )
            }
       


          </div>


     {verificationSent && (
  <div className="bg-yellow-100 border border-yellow-400 text-yellow-700 px-4 py-3 rounded mt-4">
    📧 A verification link has been sent to your email. Please check and verify.
  </div>
)}


        </div>
<div className="w-full md:w-1/2 min-h-[300px] md:min-h-full">
  <img
    src={image}
    alt="Influencer Step"
    className="w-full h-full object-cover md:object-contain"
  />
</div>


      </div>
    </div>
    </div>
  );
};
export default InfluencerForm;

























